//  "10221" and "38299" are reference numbers from wordpress that we get after tagging each post to its language in order to make the change between the languages
export const EN_REFERENCE_NUMBER = "10221";
export const AR_REFERENCE_NUMBER = "38299";
export const BLOGS_API_URL =
  "https://public-api.wordpress.com/wp/v2/sites/safeplace102505649.wordpress.com/posts";
